var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-wrapper"},[_c('router-view'),_vm._v(" "),_c('MyLogin',{ref:"mylogin",on:{"successFn":_vm.getMyInfo}}),_vm._v(" "),_c('MyBind')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }